var Vue = require('vue');

Vue.component('email', {
	props:['left','right','title'],
	template:"<a :href=\"'mailto:'+[[left]]+'@'+[[right]]\" target=\"_blank\" data-icon=\"mail\" v-html=\"title\"></a>",

});